require('intersection-observer');
import { useEffect, useState } from "react";

export const useIntersect = ( ref, { threshold, root, rootMargin, disableOnTrigger=false }) => {
  // configure the state
  const [state, setState] = useState({
    entry: undefined,
    triggered: false,
    observer: undefined
  });

  const observer = new window.IntersectionObserver(
    (entries, observerInstance) => {

      setState({
        entry: entries[0],
        triggered: true,
        observer: observerInstance
      });

      if (disableOnTrigger) {
        // unobserve the element once viewed
        observerInstance.unobserve(ref.current);
      };

      return;
    },
    {
      threshold: threshold || 0,
      root: root || null,
      rootMargin: rootMargin || "0%"
    }
  );

  useEffect(() => {
    // check that the element exists
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return [state.entry, state.observer];
};